import { z } from 'zod'

export const PROCESSOR_EXCEPTION_CONTRACT_VERSION = '1.0.0' as const

const contractVersionResponse = z.object({
  contract_version: z.string().min(1),
}).passthrough()

export const processorBindingHealthResponseSchema = z.object({
  contract_version: z.string().min(1),
  mode: z.string().min(1),
  syncAgents: z.array(z.string()),
  uptime_s: z.number().int().nonnegative(),
}).passthrough()

export const processorLlmResponseSchema = contractVersionResponse

export const processorServiceHealthResponseSchema = z.object({
  status: z.string().min(1),
  service: z.string().min(1),
  version: z.string().min(1),
  timestamp: z.string().min(1),
}).passthrough()

export const processorInternalProcessTaskResponseSchema = z.union([
  z.object({ status: z.string().min(1) }).passthrough(),
  z.object({ error: z.string().min(1) }).passthrough(),
])

export const processorPreflightAsyncQueuePublicationResponseSchema = processorLlmResponseSchema
export const processorGetAsyncOutputStatusResponseSchema = processorLlmResponseSchema
export const processorAssembleAsyncProviderRequestResponseSchema = processorLlmResponseSchema
export const processorPreflightAsyncProviderCredentialsResponseSchema = processorLlmResponseSchema
export const processorPreflightAsyncProductConsumptionResponseSchema = processorLlmResponseSchema
export const processorPreflightAsyncRawOutputAccessResponseSchema = processorLlmResponseSchema
export const processorPreflightAsyncRawPayloadAccessResponseSchema = processorLlmResponseSchema
export const processorPreflightAsyncCompletionGatesResponseSchema = processorLlmResponseSchema
export const processorPreflightAsyncCostCreditResponseSchema = processorLlmResponseSchema
export const processorRunSyncResponseSchema = processorLlmResponseSchema
export const processorPreflightExecutionLogMetadataResponseSchema = processorLlmResponseSchema
export const processorPreflightExecutionHandoffMatrixResponseSchema = processorLlmResponseSchema
export const processorPreflightPhase9CostAttributionMatrixResponseSchema = processorLlmResponseSchema
export const processorPreflightPhase9MigrationReadinessResponseSchema = processorLlmResponseSchema
export const processorPreflightPhase9ReleaseReadinessResponseSchema = processorLlmResponseSchema
export const processorPreflightPhase9SideEffectGatesResponseSchema = processorLlmResponseSchema
export const processorPreflightPhase9PromptLineageMatrixResponseSchema = processorLlmResponseSchema
export const processorPreflightPhase9RawOutputAccessMatrixResponseSchema = processorLlmResponseSchema
export const processorPreflightPhase9ProductConsumptionMatrixResponseSchema = processorLlmResponseSchema
export const processorPreflightProductLaunchReadinessMatrixResponseSchema = processorLlmResponseSchema
export const processorPreflightPromptAdminCreateEvidenceResponseSchema = processorLlmResponseSchema
export const processorPreflightPromptAdminUpdateEvidenceResponseSchema = processorLlmResponseSchema
export const processorApplyPromptAdminCreateMutationResponseSchema = processorLlmResponseSchema
export const processorApplyPromptAdminUpdateMutationResponseSchema = processorLlmResponseSchema
export const processorPreflightPromptAdminMutationResponseSchema = processorLlmResponseSchema
export const processorPreflightPromptPromotionEvidenceResponseSchema = processorLlmResponseSchema
export const processorApplyPromptPromotionMutationResponseSchema = processorLlmResponseSchema
export const processorPreflightPromptAdminReadinessResponseSchema = processorLlmResponseSchema
export const processorPreflightPromptAdminReadinessMatrixResponseSchema = processorLlmResponseSchema
export const processorPreflightPromptAdminMutationMatrixResponseSchema = processorLlmResponseSchema
export const processorApplyPromptRollbackMutationResponseSchema = processorLlmResponseSchema
export const processorPreflightPromptAdminRollbackEvidenceResponseSchema = processorLlmResponseSchema
export const processorLookupPromptResponseSchema = processorLlmResponseSchema
export const processorPreflightPromptSplitMutationResponseSchema = processorLlmResponseSchema
export const processorApplyPromptSplitMutationResponseSchema = processorLlmResponseSchema
export const processorPreflightPromptSplitReadinessResponseSchema = processorLlmResponseSchema
export const processorPreflightProviderCapabilityResponseSchema = processorLlmResponseSchema
export const processorPreflightProviderCapabilityMatrixResponseSchema = processorLlmResponseSchema
export const processorPreflightProviderCredentialMatrixResponseSchema = processorLlmResponseSchema
export const processorPreflightAgentRegistrationReadinessResponseSchema = processorLlmResponseSchema
export const processorPreflightSyntheticAgentRegistryMatrixResponseSchema = processorLlmResponseSchema
export const processorPrepareSyncExecutionResponseSchema = processorLlmResponseSchema
export const processorPersistSyncExecutionResponseSchema = processorLlmResponseSchema
export const processorPreflightSyncRunReadinessResponseSchema = processorLlmResponseSchema
export const processorGetSyncExecutionStatusResponseSchema = processorLlmResponseSchema
export const processorPersistSyncOutputResponseSchema = processorLlmResponseSchema
export const processorPersistSyncFailureResponseSchema = processorLlmResponseSchema
export const processorGetSyncFailureStatusResponseSchema = processorLlmResponseSchema
export const processorGetSyncOutputStatusResponseSchema = processorLlmResponseSchema
export const processorPreflightProductConsumptionResponseSchema = processorLlmResponseSchema
export const processorPreflightSyncRawOutputAccessResponseSchema = processorLlmResponseSchema
export const processorPreflightSyncProviderResponseSchema = processorLlmResponseSchema
export const processorAssembleSyncProviderRequestResponseSchema = processorLlmResponseSchema
export const processorPreflightSyncProviderCredentialsResponseSchema = processorLlmResponseSchema
export const processorPreflightSyncRawPayloadAccessResponseSchema = processorLlmResponseSchema
export const processorPreflightSyncCompletionGatesResponseSchema = processorLlmResponseSchema
export const processorPreflightSyncQueueFallbackResponseSchema = processorLlmResponseSchema
export const processorPreflightSyncCostCreditResponseSchema = processorLlmResponseSchema
export const processorProveOpenrouterSyntheticExecutionResponseSchema = processorLlmResponseSchema
export const processorProveResultQueueDlqResponseSchema = processorLlmResponseSchema

export type ProcessorBindingHealthResponse = z.infer<typeof processorBindingHealthResponseSchema>
export type ProcessorLlmResponse = z.infer<typeof processorLlmResponseSchema>
export type ProcessorServiceHealthResponse = z.infer<typeof processorServiceHealthResponseSchema>
export type ProcessorInternalProcessTaskResponse = z.infer<typeof processorInternalProcessTaskResponseSchema>
export type ProcessorPreflightAsyncQueuePublicationResponse = ProcessorLlmResponse
export type ProcessorGetAsyncOutputStatusResponse = ProcessorLlmResponse
export type ProcessorAssembleAsyncProviderRequestResponse = ProcessorLlmResponse
export type ProcessorPreflightAsyncProviderCredentialsResponse = ProcessorLlmResponse
export type ProcessorPreflightAsyncProductConsumptionResponse = ProcessorLlmResponse
export type ProcessorPreflightAsyncRawOutputAccessResponse = ProcessorLlmResponse
export type ProcessorPreflightAsyncRawPayloadAccessResponse = ProcessorLlmResponse
export type ProcessorPreflightAsyncCompletionGatesResponse = ProcessorLlmResponse
export type ProcessorPreflightAsyncCostCreditResponse = ProcessorLlmResponse
export type ProcessorRunSyncResponse = ProcessorLlmResponse
export type ProcessorPreflightExecutionLogMetadataResponse = ProcessorLlmResponse
export type ProcessorPreflightExecutionHandoffMatrixResponse = ProcessorLlmResponse
export type ProcessorPreflightPhase9CostAttributionMatrixResponse = ProcessorLlmResponse
export type ProcessorPreflightPhase9MigrationReadinessResponse = ProcessorLlmResponse
export type ProcessorPreflightPhase9ReleaseReadinessResponse = ProcessorLlmResponse
export type ProcessorPreflightPhase9SideEffectGatesResponse = ProcessorLlmResponse
export type ProcessorPreflightPhase9PromptLineageMatrixResponse = ProcessorLlmResponse
export type ProcessorPreflightPhase9RawOutputAccessMatrixResponse = ProcessorLlmResponse
export type ProcessorPreflightPhase9ProductConsumptionMatrixResponse = ProcessorLlmResponse
export type ProcessorPreflightProductLaunchReadinessMatrixResponse = ProcessorLlmResponse
export type ProcessorPreflightPromptAdminCreateEvidenceResponse = ProcessorLlmResponse
export type ProcessorPreflightPromptAdminUpdateEvidenceResponse = ProcessorLlmResponse
export type ProcessorApplyPromptAdminCreateMutationResponse = ProcessorLlmResponse
export type ProcessorApplyPromptAdminUpdateMutationResponse = ProcessorLlmResponse
export type ProcessorPreflightPromptAdminMutationResponse = ProcessorLlmResponse
export type ProcessorPreflightPromptPromotionEvidenceResponse = ProcessorLlmResponse
export type ProcessorApplyPromptPromotionMutationResponse = ProcessorLlmResponse
export type ProcessorPreflightPromptAdminReadinessResponse = ProcessorLlmResponse
export type ProcessorPreflightPromptAdminReadinessMatrixResponse = ProcessorLlmResponse
export type ProcessorPreflightPromptAdminMutationMatrixResponse = ProcessorLlmResponse
export type ProcessorApplyPromptRollbackMutationResponse = ProcessorLlmResponse
export type ProcessorPreflightPromptAdminRollbackEvidenceResponse = ProcessorLlmResponse
export type ProcessorLookupPromptResponse = ProcessorLlmResponse
export type ProcessorPreflightPromptSplitMutationResponse = ProcessorLlmResponse
export type ProcessorApplyPromptSplitMutationResponse = ProcessorLlmResponse
export type ProcessorPreflightPromptSplitReadinessResponse = ProcessorLlmResponse
export type ProcessorPreflightProviderCapabilityResponse = ProcessorLlmResponse
export type ProcessorPreflightProviderCapabilityMatrixResponse = ProcessorLlmResponse
export type ProcessorPreflightProviderCredentialMatrixResponse = ProcessorLlmResponse
export type ProcessorPreflightAgentRegistrationReadinessResponse = ProcessorLlmResponse
export type ProcessorPreflightSyntheticAgentRegistryMatrixResponse = ProcessorLlmResponse
export type ProcessorPrepareSyncExecutionResponse = ProcessorLlmResponse
export type ProcessorPersistSyncExecutionResponse = ProcessorLlmResponse
export type ProcessorPreflightSyncRunReadinessResponse = ProcessorLlmResponse
export type ProcessorGetSyncExecutionStatusResponse = ProcessorLlmResponse
export type ProcessorPersistSyncOutputResponse = ProcessorLlmResponse
export type ProcessorPersistSyncFailureResponse = ProcessorLlmResponse
export type ProcessorGetSyncFailureStatusResponse = ProcessorLlmResponse
export type ProcessorGetSyncOutputStatusResponse = ProcessorLlmResponse
export type ProcessorPreflightProductConsumptionResponse = ProcessorLlmResponse
export type ProcessorPreflightSyncRawOutputAccessResponse = ProcessorLlmResponse
export type ProcessorPreflightSyncProviderResponse = ProcessorLlmResponse
export type ProcessorAssembleSyncProviderRequestResponse = ProcessorLlmResponse
export type ProcessorPreflightSyncProviderCredentialsResponse = ProcessorLlmResponse
export type ProcessorPreflightSyncRawPayloadAccessResponse = ProcessorLlmResponse
export type ProcessorPreflightSyncCompletionGatesResponse = ProcessorLlmResponse
export type ProcessorPreflightSyncQueueFallbackResponse = ProcessorLlmResponse
export type ProcessorPreflightSyncCostCreditResponse = ProcessorLlmResponse
export type ProcessorProveOpenrouterSyntheticExecutionResponse = ProcessorLlmResponse
export type ProcessorProveResultQueueDlqResponse = ProcessorLlmResponse
